<script setup>
import { Avatar } from '@dashhudson/dashing-ui/avatar';
import { DropdownBase } from '@dashhudson/dashing-ui/dropdown-panel';
import { computed, ref } from 'vue';

import BrandSwitcher from '@/components/layout/navigation/BrandSwitcher.vue';
import { MIXPANEL_VALUES } from '@/components/layout/navigation/constants';
import UtilityNavigation from '@/components/layout/navigation/UtilityNavigation.vue';
import { useIdentityStore } from '@/stores/identity';
import { useImpersonatorStore } from '@/stores/impersonator';
import { trackNavigation } from '@/utils/analytics/tracking';
import { getBrandInitials } from '@/utils/brand';

const identityStore = useIdentityStore();
const impersonatorStore = useImpersonatorStore();

const brandAvatarUrl = computed(() => identityStore.currentBrand?.avatarUrl);

const shown = ref(false);

function trackOpen(isBeingOpened) {
  if (isBeingOpened) {
    trackNavigation(MIXPANEL_VALUES.UTILITY_MENU.ROOT);
  }
}

function close(event) {
  shown.value = false;
  if (event?.tracking) {
    trackNavigation(MIXPANEL_VALUES.UTILITY_MENU.ROOT, event.tracking);
  }
}
</script>

<template>
  <DropdownBase
    v-model:shown="shown"
    placement="right-end"
    visual-bridge
    strategy="fixed"
    @update:shown="trackOpen($event)"
  >
    <div class="!relative !h-10 !w-10" data-test="UtilityPanelAvatar">
      <Avatar
        v-dash-tooltip="{
          content: identityStore.currentBrand?.name,
          theme: 'dash-tooltip--nav',
        }"
        :image="brandAvatarUrl"
        :label="!!brandAvatarUrl ? null : getBrandInitials(identityStore.currentBrand)"
        size="lg"
        class="dash-transition-md !cursor-pointer hover:elevation"
      />
      <div
        v-if="impersonatorStore.isImpersonating"
        class="absolute right-0 top-0 !translate-x-1/3 -translate-y-1/3"
      >
        <Avatar label="DH" size="sm" class="!select-none" />
      </div>
    </div>
    <template #content>
      <div class="!grid !h-full !grid-cols-2">
        <UtilityNavigation @close="close($event)" />
        <BrandSwitcher @selected="close" />
      </div>
    </template>
  </DropdownBase>
</template>
